<div mat-dialog-content>
  <div class="mat-dialog-content">
    @if (this.patient) {
      <div>
        <div class="section-container">
          <div class="title-header">
            <h1>Dados Pessoais</h1>
          </div>
          <div class="row section-personal-data">
            @if (patient.socialName) {
              <div>
                <span><b>Nome Social: </b></span>
                <span>{{patient.socialName}}</span>
              </div>
            }
            @if (patient.patientName) {
              <div>
                <span><b>Nome: </b></span>
                <span>{{patient.patientName}}</span>
              </div>
            }
            @if (patient.birthDate) {
              <div>
                <span><b>Data de Nascimento: </b></span>
                <span>{{patient.birthDate | date: 'dd/MM/yyyy'}}</span>
              </div>
            }
            @if (patient.birthDate) {
              <div>
                <span><b>Idade: </b></span>
                <span>{{patient.patientAge}}</span>
              </div>
            }
            <!-- Antigo Gênero -->
            @if (patient.genderName) {
              <div>
                <span><b>Sexo: </b></span>
                <span>{{patient.genderName}}</span>
              </div>
            }
            @if (patient.genderIdentityName) {
              <div>
                <span><b>Gênero: </b></span>
                <span>{{patient.genderIdentityName}}</span>
              </div>
            }
            @if (patient.cpf) {
              <div>
                <span><b>CPF: </b></span>
                <span>{{patient.cpf}}</span>
              </div>
            }
            @if (patient.cns) {
              <div>
                <span><b>CNS: </b></span>
                <span>{{patient.cns}}</span>
              </div>
            }
            @if (patient.phone1) {
              <div>
                <span><b>Telefone 1: </b></span>
                <span>{{patient.phone1}}</span>
              </div>
            }
            @if (patient.phone2) {
              <div>
                <span><b>Telefone 2: </b></span>
                <span>{{patient.phone2}}</span>
              </div>
            }
            @if (patient.raceName) {
              <div>
                <span><b>Raça: </b></span>
                <span>{{patient.raceName}}</span>
              </div>
            }
            @if (patient.motherName) {
              <div>
                <span><b>Nome da Mãe: </b></span>
                <span>{{patient.motherName}}</span>
              </div>
            }
            @if (patient.fatherName) {
              <div>
                <span><b>Nome do Pai: </b></span>
                <span>{{patient.fatherName}}</span>
              </div>
            }
            @if (patient.profession) {
              <div>
                <span><b>Profissão: </b></span>
                <span>{{patient.profession}}</span>
              </div>
            }
            @if (patient.educationName) {
              <div>
                <span><b>Escolaridade: </b></span>
                <span>{{patient.educationName}}</span>
              </div>
            }
            @if (patient.rg) {
              <div>
                <span><b>RG: </b></span>
                <span>{{patient.rg}}</span>
              </div>
            }
            @if (patient.expeditionIssuer) {
              <div>
                <span><b>Órgão Expeditor: </b></span>
                <span>{{patient.expeditionIssuer}}</span>
              </div>
            }
            @if (patient.expeditionDate) {
              <div>
                <span><b>Data de Expedição: </b></span>
                <span>{{patient.expeditionDate | date: 'dd/MM/yyyy'}}</span>
              </div>
            }
            @if (patient.birthCountry) {
              <div>
                <span><b>Nacionalidade: </b></span>
                <span>{{patient.birthCountry}}</span>
              </div>
            }
            @if (patient.birthState) {
              <div>
                <span><b>Estado de Origem: </b></span>
                <span>{{patient.birthState}}</span>
              </div>
            }
            @if (patient.birthCity) {
              <div>
                <span><b>Cidade de Origem: </b></span>
                <span>{{patient.birthCity}}</span>
              </div>
            }
          </div>
        </div>
        <div class="section-container">
          <div class="title-header">
            <h1>Endereço</h1>
          </div>
          <div class="row section-address">
            @if (patient.zipCode) {
              <div>
                <span><b>CEP: </b></span>
                <span>{{patient.zipCode}}</span>
              </div>
            }
            @if (patient.street) {
              <div>
                <span><b>Logradouro: </b></span>
                <span>{{patient.street}}</span>
              </div>
            }
            @if (patient.houseNumber) {
              <div>
                <span><b>Número: </b></span>
                <span>{{patient.houseNumber}}</span>
              </div>
            }
            @if (patient.apartmentNumber) {
              <div>
                <span><b>Complemento: </b></span>
                <span>{{patient.apartmentNumber}}</span>
              </div>
            }
            @if (patient.neighborhood) {
              <div>
                <span><b>Bairro: </b></span>
                <span>{{patient.neighborhood}}</span>
              </div>
            }
            @if (patient.city) {
              <div>
                <span><b>Cidade: </b></span>
                <span>{{patient.city}}</span>
              </div>
            }
            @if (patient.state) {
              <div>
                <span><b>Estado: </b></span>
                <span>{{patient.state}}</span>
              </div>
            }
            @if (patient.country) {
              <div>
                <span><b>País: </b></span>
                <span>{{patient.country}}</span>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
<div mat-dialog-footer class="footer-modal col-12">
  <div class="col-12 col-md-4">
    <button mat-flat-button color="accent" class="btn-block" (click)="clickClosed()" type="button">
      <span>Fechar</span>
    </button>
  </div>
  <div class="col-12 col-md-4">
    <button mat-flat-button color="primary" class="btn-block" (click)="clickEdit()" type="button">
      <span>Editar dados</span>
    </button>
  </div>
</div>